import { type ThemeColorModes, setGlobalTheme } from '@atlaskit/tokens';

import * as store from '../../navigation-store';

interface CoreIFrameWindow extends Window {
  setTheme: (theme: string) => void;
}

export const handleGlobalThemeChange = (theme: ThemeColorModes) => {
  setGlobalTheme({ colorMode: theme });
  store.setColorTheme(theme);

  // Manually update embedded core UI views
  const settingsFrame = document.getElementById(
    'settings-frame'
  ) as HTMLIFrameElement | null;
  const settingsFrameWindow: null | undefined | CoreIFrameWindow =
    settingsFrame?.contentWindow as CoreIFrameWindow;
  if (
    settingsFrameWindow &&
    typeof settingsFrameWindow.setTheme === 'function'
  ) {
    settingsFrameWindow.setTheme(theme);
  }
};

export const getCurrentTheme = (): ThemeColorModes => {
  return store.getColorTheme() || 'light';
};

export const urls = {
  privacyPolicy: 'https://www.atlassian.com/legal/privacy-policy',
  atlassianResearchGroup: 'https://www.atlassian.com/research-group',
  contactSupportLink:
    'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues',
};
